import React, { FunctionComponent, useState, useEffect, useRef } from 'react';
import {  Modal, Button, Container, Row, Col, Form, Alert, Spinner } from 'react-bootstrap';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faPaypal } from '@fortawesome/free-brands-svg-icons';


type addCreditCardProps = {
  show: boolean,
  handleClose: () => void
}
const addCreditCardModal:FunctionComponent<addCreditCardProps> = (props) => {

  const [cardNumber, setCardNumber] = useState(0);
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [cvv, setCVV] = useState('');
  const [cardholder, setCardholder] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitDisabled, setSubmitDisabled] = useState(true);


  const yearInputRef = useRef(null);
  const cvvInputRef = useRef(null);

  const changeCardNumber = (e) => {
    var newCardNumber = e.target.value.split(" ").join(""); // remove hyphens
    setCardNumber(newCardNumber);
    if (newCardNumber.length > 0) {
      newCardNumber = newCardNumber.match(new RegExp('.{1,4}', 'g')).join(" ");
      e.target.value = newCardNumber;
    }
  }

  const changeMonth = (e) => {
    const newMonth = e.target.value;
    setMonth(newMonth);
    if (newMonth.toString().length == e.target.maxLength){
      yearInputRef.current.focus();
    }
  }

  const changeYear = (e) => {
    const newYear = e.target.value;
    setYear(newYear);
    if (newYear.toString().length == e.target.maxLength){
      cvvInputRef.current.focus();
    }
  }

  const changeCardholder = (e) => {
    const newCardholder = e.target.value;
    setCardholder(newCardholder);
  }

  const changeCVV = (e) => {
    const newCVV = e.target.value;
    setCVV(newCVV);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setLoading(true);
    setError('');// Limpiamos los posibles errores
    const payload = {
      card_number: cardNumber,
      month_exp: month,
      year_exp: year,
      cvv: cvv,
      card_name: cardholder
    }
    const result = await ObexRequestHandler.post('/cards', payload);
    const { success, data, message } = result;
    if (success){
      setLoading(false);
      setSuccess(data);
        setTimeout(function() { 
          setSuccess('');
          setSubmitDisabled(true);
          props.handleClose();
          }.bind(this), 1000)
    } else {
      setError(message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cardNumber && month && year && cvv && cardholder){
      setSubmitDisabled(false);
    }
  })
  return(
    <Modal dialogClassName="addons-dialog obex-dialog"
      show={props.show} 
      onHide={props.handleClose}
      animation={false}
      scrollable>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="text-center mx-auto">
          <Col md="12" className="addons-title">
            <span>Add Payment Method</span>
          </Col>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md="10" className="mx-auto">
            <Form className="obex-form payment-method-form" onSubmit={handleSubmit}>
              {/* <Form.Row className="py-2">
                <Form.Label column sm="12" className="obex-form-label">
                  How would you like to pay?
                </Form.Label>
                <Col md="1" className="text-right py-1 pr-5">
                  <Form.Check
                    type="radio"
                    value="CreditCard"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios1"
                  />
                </Col>
                <Col className="type-payment-method py-1 pl-3">
                  <span><FontAwesomeIcon icon={faCreditCard}/> Credit Card</span>
                </Col>
              </Form.Row>
              <Form.Row className="py-2 mb-3">
                <Col md="1" className="text-right py-1 pr-5">
                  <Form.Check
                    type="radio"
                    value="PayPal"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios2"
                  />
                </Col>
                <Col className="type-payment-method py-1 pl-3">
                  <span><FontAwesomeIcon icon={faPaypal}/> Paypal</span>
                </Col>
              </Form.Row> */}
              <Form.Row className="mb-3">
                <Form.Label column sm="12" className="obex-form-label">
                  Cardholder's name*
                </Form.Label>
                <Form.Control required type="text" placeholder="Cardholder's name" onChange={changeCardholder}/>
              </Form.Row>
              <Form.Row className="mb-3">
                <Form.Label column sm="12" className="obex-form-label">
                  Credit card number*
                </Form.Label>
                <Col md="12">
                  <Form.Control required type="text" maxLength={19} placeholder="Card Number" onChange={changeCardNumber}/>
                </Col>
              </Form.Row>
              <Form.Row className="mb-3">
                <Col md="4" className="ml-auto">
                  <Row>
                    <Form.Label column sm="12" className="obex-form-label">
                      Expiration date*
                    </Form.Label>
                    <Col md="6">
                      <Form.Control required type="text" maxLength={2} placeholder="Month" onChange={changeMonth}/>
                    </Col>
                    <Col md="6" className="pl-0">
                      <Form.Control required type="text" maxLength={4} placeholder="Year" onChange={changeYear}/>
                    </Col>
                  </Row>
                </Col>
                <Col md="3">
                  <Form.Label column sm="12" className="obex-form-label">
                    CVV/CVV2*
                  </Form.Label>
                  <Form.Control required type="text" maxLength={4} placeholder="CVV" onChange={changeCVV}/>
                </Col>
              </Form.Row>
              
              <Form.Row className="my-3">
                <Col md="4" className="ml-auto">
                  <Button disabled={submitDisabled} type="submit" className="btn-block obex-btn btn-green">
                      Add Payment {success && <FontAwesomeIcon icon={faCheck}/>}
                    {loading && <Spinner animation="border" size="sm" style={{ marginLeft: '8px' }}/>}
                  </Button>
                </Col>
              </Form.Row>
            </Form>
            {error && <Alert variant="danger">
              {error}
            </Alert>}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default addCreditCardModal;